<ng-template #menuTemplate let-pub="pub">
  @let canDownloadPub = canDownload(pub);
  @let canDeletePub = canDelete(pub);
  @let canPausePub = canPause(pub);
  @let canDownloadFilesPub = canDownloadFiles(pub);

  @if (canDownloadPub || canDeletePub || canPausePub || canDownloadFilesPub) {
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="download">
      <mat-icon svgIcon="menu-kebab"></mat-icon>
    </button>
  }
  @if (!showOffline && pub.status === "offline") {
    <button disabled mat-icon-button>
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  }
  <mat-menu #menu="matMenu">
    @if (canDownloadPub) {
      <button mat-menu-item class="icon" (click)="replicate(pub)">
        <mat-icon svgIcon="download" color="primary"></mat-icon>
        {{ "cards.actions.download" | translate: { pubSize: getDiskSize(pub) | byteFormat } }}
      </button>
    }
    @if (canDeletePub) {
      <button mat-menu-item class="icon" (click)="deletePub(pub, $event)">
        <mat-icon svgIcon="delete" color="primary"></mat-icon>
        {{ "cards.actions.remove" | translate }}
      </button>
    }
    @if (canPausePub) {
      <button mat-menu-item class="icon" (click)="stopReplication($event)">
        <mat-icon svgIcon="pause" color="primary"></mat-icon>
        {{ "cards.actions.pause" | translate }}
      </button>
    }
    @if (canDownloadFilesPub) {
      <button mat-menu-item class="icon" (click)="downloadFiles(pub)">
        <mat-icon svgIcon="save" color="primary"></mat-icon>
        {{ "cards.actions.downloadFile" | translate: { fileSize: pub.fileSize | byteFormat } }}
      </button>
    }
  </mat-menu>
</ng-template>

<o-card-pub
  [cardNavigate]="!isDownloading"
  [pub]="lastRev"
  [searchInPub]="searchInPub"
  [isShowProductDescription]="displayOldRevs">
  @if (lastRev.packageId !== "user_manual") {
    <ng-container menu>
      <ng-container *ngTemplateOutlet="menuTemplate; context: { pub: lastRev }"></ng-container>
    </ng-container>
  }
  <ng-container content class="status-div">
    <o-pub-replication-progress [pub]="lastRev"></o-pub-replication-progress>
    @if (downloadInfo | async; as download) {
      <div class="progress-bar">
        @if (download.progress < 100) {
          Downloading
          <mat-progress-bar
            [mode]="download.state === downloadState.PENDING ? 'query' : 'determinate'"
            [value]="download.progress">
          </mat-progress-bar>
          {{ download.progress }}%
        }
      </div>
    }
    @if (lastRev.packageId !== "user_manual" && !lastRev.isLast && !isDownloading) {
      <div class="warning">
        {{ "publist.new.revision" | translate }}
      </div>
    }
    @if (lastRev.status === revisionStatus.IMPORTED) {
      <div class="warning">
        {{ "products.labels.imported" | translate }}
      </div>
    }
  </ng-container>
  @if (lastRev.packageId !== "user_manual") {
    <div footer class="actions">
      <p class="product-title">
        {{ lastRev?.title }}
      </p>
      @if (oldRevs?.length || lastRev.description) {
        <button mat-button class="basic-button old-rev-button" (click)="toggleOldRevs($event)">
          {{ (displayOldRevs ? "less" : "more") | translate }}
        </button>
      }
    </div>
  }
</o-card-pub>

@if (displayOldRevs) {
  @for (rev of oldRevs; track rev._id) {
    <o-card-pub [cardNavigate]="!isDownloading" [searchInPub]="searchInPub" [pub]="rev" [isLight]="true">
      <div content class="status-div">
        <o-pub-replication-progress [pub]="rev"></o-pub-replication-progress>
      </div>
      <div menu>
        <ng-container *ngTemplateOutlet="menuTemplate; context: { pub: rev }"></ng-container>
      </div>
      <div footer class="warning">{{ "publist.new.revision" | translate }}</div>
    </o-card-pub>
  }
}
